<template>
	<div class="container">
		<div class="">
			<div class="">
				<div class="table_box">
					<p>年终库存可视化表格</p>
					<el-table :data="list" class="table" style="width: 100%" height="100%" border size="mini" header-cell-class-name="list_table_th">
						<el-table-column prop="filed1" label="月份" show-overflow-tooltip></el-table-column>
						<el-table-column prop="filed2" label="上月结算库存" show-overflow-tooltip></el-table-column>
						<el-table-column prop="filed3" label="入库方数" show-overflow-tooltip></el-table-column>
						<el-table-column prop="filed4" label="出库方数" show-overflow-tooltip></el-table-column>
						<el-table-column prop="filed5" label="本月结算库存" show-overflow-tooltip></el-table-column>
					</el-table>
				</div>
				<div class="pie_chart">
					<p>产品销售占比</p>
					<div class="tabs">
						<div :class="{ current : current == '1' }" @click="current = '1'">1周</div>
						<div :class="{ current : current == '2' }" @click="current = '2'">1个月</div>
						<div :class="{ current : current == '3' }" @click="current = '3'">3个月</div>
						<div :class="{ current : current == '4' }" @click="current = '4'">6个月</div>
						<div :class="{ current : current == '5' }" @click="current = '5'">1年</div>
						<div :class="{ current : current == '6' }" @click="current = '6'">2年</div>
					</div>
					<div class="" id="pie"></div>
				</div>
			</div>
			<div class="" id="map">
			</div>
			<div class="">
				<div class="bar_chart">
					<p>出入库柱状图</p>
					<div class="tabs">
						<div :class="{ current : current == '1' }" @click="current = '1'">1周</div>
						<div :class="{ current : current == '2' }" @click="current = '2'">1个月</div>
						<div :class="{ current : current == '3' }" @click="current = '3'">3个月</div>
						<div :class="{ current : current == '4' }" @click="current = '4'">6个月</div>
						<div :class="{ current : current == '5' }" @click="current = '5'">1年</div>
						<div :class="{ current : current == '6' }" @click="current = '6'">2年</div>
					</div>
					<div id="bar">

					</div>
				</div>
				<div class="line_chart">
					<p>出入库线性图</p>
					<div class="tabs">
						<div :class="{ current : current == '1' }" @click="current = '1'">1周</div>
						<div :class="{ current : current == '2' }" @click="current = '2'">1个月</div>
						<div :class="{ current : current == '3' }" @click="current = '3'">3个月</div>
						<div :class="{ current : current == '4' }" @click="current = '4'">6个月</div>
						<div :class="{ current : current == '5' }" @click="current = '5'">1年</div>
						<div :class="{ current : current == '6' }" @click="current = '6'">2年</div>
					</div>
					<div id="line">

					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped lang="scss">
	.container{
		display: flex; align-items: stretch; height: 100%; color: #fff;  overflow: auto; background: url('/icon/charts/bg.png') no-repeat center bottom; background-size: cover; border-top:11px solid #EEEFF2; border-left: 11px solid #EEEFF2;
		& > div{ flex: 1; display: flex; justify-content: center; align-items: center; height: 100%; width: 1808px; padding: 13px 20px; }
		p{ padding: 0; margin: 0; }

		.table_box{
			width:570px; height:428px; padding: 15px; background:rgba(255,255,255,0.1); border:1px solid rgba(112,112,112,0.1); border-radius:3px; display: flex; flex-direction: column; align-items: stretch;
			p{ font-size: 16px; margin-bottom: 10px; }
			.table{ flex:1; }
		}
		.tabs{
			display: flex; align-items: center; justify-content: space-between;
			& > div{ border-bottom: 4px solid transparent; padding: 5px; cursor: pointer; }
			& > div.current{ border-bottom: 4px solid #B21111; }
		}
		.pie_chart{
			width:570px; height:411px; display: flex; flex-direction: column; align-items: stretch; background:rgba(255,255,255,0.1); border:1px solid rgba(112,112,112,0.1); border-radius:3px; margin-top:8px; padding: 15px;
			p{ font-size: 16px; margin-bottom: 10px; text-align: left; }
		}
		.bar_chart{
			width:556px; height:428px; background:rgba(255,255,255,0.1); border:1px solid rgba(112,112,112,0.1); border-radius:3px; display: flex; flex-direction: column; align-items: stretch; padding: 15px;
			p{ font-size: 16px; margin-bottom: 10px; text-align: left; }
		}
		.line_chart{
			width:556px; height:411px; display: flex; flex-direction: column; align-items: stretch; background:rgba(255,255,255,0.1); border:1px solid rgba(112,112,112,0.1); border-radius:3px; margin-top:8px; padding: 15px;
			p{ font-size: 16px; margin-bottom: 10px; text-align: left; }
		}
		#pie{ flex: 1; }
		#bar{ flex: 1; }
		#line{ flex: 1; }
		#map{ width:  757px; height: 556px; margin: 0 40px;   }
	}
</style>

<script>
export default {
	data() {
		return {
			list : [
				{
					filed1: "一月",
					filed2: 200.365,
					filed3: 200.365,
					filed4: 200.365,
					filed5: 200.365,
				},
				{
					filed1: "二月",
					filed2: 254.255,
					filed3: 254.255,
					filed4: 254.255,
					filed5: 254.255,
				},
				{
					filed1: "三月",
					filed2: 255.555,
					filed3: 255.555,
					filed4: 255.555,
					filed5: 255.555,
				},
				{
					filed1: "四月",
					filed2: 442.336,
					filed3: 442.336,
					filed4: 442.336,
					filed5: 442.336,
				},
				{
					filed1: "五月",
					filed2: 254.255,
					filed3: 254.255,
					filed4: 254.255,
					filed5: 254.255,
				},
				{
					filed1: "六月",
					filed2: 254.255,
					filed3: 254.255,
					filed4: 254.255,
					filed5: 254.255,
				},
				{
					filed1: "七月",
					filed2: 254.255,
					filed3: 254.255,
					filed4: 254.255,
					filed5: 254.255,
				},
				{
					filed1: "八月",
					filed2: 254.255,
					filed3: 254.255,
					filed4: 254.255,
					filed5: 254.255,
				},
				{
					filed1: "九月",
					filed2: 254.255,
					filed3: 254.255,
					filed4: 254.255,
					filed5: 254.255,
				},
				{
					filed1: "十月",
					filed2: 254.255,
					filed3: 254.255,
					filed4: 254.255,
					filed5: 254.255,
				},
				{
					filed1: "十一月",
					filed2: 254.255,
					filed3: 254.255,
					filed4: 254.255,
					filed5: 254.255,
				},
				{
					filed1: "十二月",
					filed2: 254.255,
					filed3: 254.255,
					filed4: 254.255,
					filed5: 254.255,
				},
			],
			current : 0,
			pie:{},
			line:{},
			bar:{},
			map:{},
		}
	},
	components:{
	},
	computed:{
	},
	created(){
	},
	mounted(){
		this.drawLine();
		this.drawBar();
		this.drawPie();
		this.drawMap();
	},
	destroyed() {
	},
	methods: {
		drawPie(){
			if (this.pie.hasOwnProperty("id")) {
				this.pie.dispose();
			}
			this.pie = window.echarts.init(document.getElementById('pie'));
			let option = {
				tooltip : {
					trigger: 'item',
					formatter: "{b} : {c} ({d}%)"
				},
				legend: {
					type: 'scroll',
					orient: 'vertical',
					right: 10,
					top: 20,
					bottom: 20,
					data:['A产品','B产品','C产品','D产品','其他'],
					textStyle: {
						color:"#fff"
					}
				},
				series : [
					{
						type: 'pie',
						radius : '55%',
						center: ['50%', '60%'],
						data:[
							{value:335, name:'A产品'},
							{value:310, name:'B产品'},
							{value:234, name:'C产品'},
							{value:135, name:'D产品'},
							{value:1548, name:'其他'}
						],
						itemStyle: {
							emphasis: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
				]
			};
			this.pie.setOption(option);
		},
		drawLine(){
			if (this.line.hasOwnProperty("id")) {
				this.line.dispose();
			}
			this.line = window.echarts.init(document.getElementById('line'));
			let option = {
				tooltip : {
					trigger: 'axis',
					axisPointer: {
						type: 'cross',
						label: {
							backgroundColor: '#6a7985'
						}
					}
				},
				xAxis: {
					type: 'category',
					data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
					nameTextStyle:{
						color: "#fff"
					},
					axisLabe:{
						color: "#fff"
					},
					axisLine:{
						lineStyle:{
							color: "#fff"
						}
					}
				},
				yAxis: {
					type: 'value',
					nameTextStyle:{
						color: "#fff"
					},
					axisLabe:{
						color: "#fff"
					},
					axisLine:{
						lineStyle:{
							color: "#fff"
						}
					}
				},
				series: [
					{
						data: [10, 52, 200, 334, 390, 330, 220],
						type: 'line',
						smooth:true,
						symbol: 'none',
						sampling: 'average',
						itemStyle: {
							color: 'transparent'
						},
						areaStyle: {
							color: new window.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#004EFF'
							}, {
								offset: 1,
								color: '#00B4FF'
							}])
						},
					},
					{
						data: [20, 72, 220, 354, 420, 360, 280],
						type: 'line',
						smooth:true,
						symbol: 'none',
						sampling: 'average',
						itemStyle: {
							color: 'transparent'
						},
						areaStyle: {
							color: new window.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#B21111'
							}, {
								offset: 1,
								color: '#FED3D3'
							}])
						},
					}
				]
			};
			this.line.setOption(option);
		},
		drawBar(){
			if (this.bar.hasOwnProperty("id")) {
				this.bar.dispose();
			}
			this.bar = window.echarts.init(document.getElementById('bar'));
			let option = {
				color: ['#3398DB'],
				tooltip : {
					trigger: 'axis',
					axisPointer : {			// 坐标轴指示器，坐标轴触发有效
						type : 'shadow'		// 默认为直线，可选为：'line' | 'shadow'
					}
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				xAxis : [
					{
						type : 'category',
						data : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
						axisTick: {
							alignWithLabel: true
						},
						nameTextStyle:{
							color: "#fff"
						},
						axisLabe:{
							color: "#fff"
						},
						axisLine:{
							lineStyle:{
								color: "#fff"
							}
						}
					}
				],
				yAxis : [
					{
						type : 'value',
						nameTextStyle:{
							color: "#fff"
						},
						axisLabe:{
							color: "#fff"
						},
						axisLine:{
							lineStyle:{
								color: "#fff"
							}
						}
					}
				],
				series : [
					{
						name:'入库',
						type:'bar',
						data:[10, 52, 200, 334, 390, 330, 220],
						itemStyle: {
							normal: {
								color: new window.echarts.graphic.LinearGradient(
									0, 0, 0, 1,
									[
										{offset: 0, color: '#00B4FF'},
										{offset: 1, color: '#004EFF'}
									]
								)
							},
						},
					},
					{
						name:'出库',
						type:'bar',
						data:[20, 72, 220, 354, 420, 360, 280],
						itemStyle: {
							normal: {
								color: new window.echarts.graphic.LinearGradient(
									0, 0, 0, 1,
									[
										{offset: 0, color: '#FED3D3'},
										{offset: 1, color: '#B21111'}
									]
								)
							},
						},
					}
				]
			};
			this.bar.setOption(option);
		},


		// 地图

		drawMap(){
			if (this.map.hasOwnProperty("id")) {
				this.map.dispose();
			}
			this.map = window.echarts.init(document.getElementById('map'));
			var data = [
				{name: '青岛', value: 18},
				{name: '上海', value: 25},
				{name: '太仓', value: 27},
				{name: '张家港', value: 52},
				{name: '天津', value: 105},
				{name: '广州', value: 38},
				{name: '宁波', value: 33},
				{name: '西安', value: 61},
				{name: '沈阳', value: 50},
			];

			var geoCoordMap = {
				'青岛':[120.33,36.07],
				'上海':[121.48,31.22],
				'太仓':[121.1,31.45],
				'张家港':[120.555821,31.875428],
				'天津':[117.2,39.13],
				'广州':[113.23,23.16],
				'宁波':[121.56,29.86],
				'西安':[108.95,34.27],
				'沈阳':[123.38,41.8],
			};

			var convertData = function (data) {
				var res = [];
				for (var i = 0; i < data.length; i++) {
					var geoCoord = geoCoordMap[data[i].name];
					if (geoCoord) {
						res.push({
							name: data[i].name,
							value: geoCoord.concat(data[i].value)
						});
					}
				}
				return res;
			};

			let option = {
				backgroundColor: 'transparent',
				title: {
					text: '全国主要城市空气质量',
					subtext: 'data from PM25.in',
					sublink: 'http://www.pm25.in',
					left: 'center',
					textStyle: {
						color: '#fff'
					}
				},
				tooltip : {
					trigger: 'item'
				},
				bmap: {
					center: [104.114129, 37.550339],
					zoom: 5,
					roam: true,
					mapStyle: {
						styleJson: [
								{
									"featureType": "water",
									"elementType": "all",
									"stylers": {
										"color": "#044161"
									}
								},
								{
									"featureType": "land",
									"elementType": "all",
									"stylers": {
										"color": "#004981"
									}
								},
								{
									"featureType": "boundary",
									"elementType": "geometry",
									"stylers": {
										"color": "#064f85"
									}
								},
								{
									"featureType": "railway",
									"elementType": "all",
									"stylers": {
										"visibility": "off"
									}
								},
								{
									"featureType": "highway",
									"elementType": "geometry",
									"stylers": {
										"color": "#004981"
									}
								},
								{
									"featureType": "highway",
									"elementType": "geometry.fill",
									"stylers": {
										"color": "#005b96",
										"lightness": 1
									}
								},
								{
									"featureType": "highway",
									"elementType": "labels",
									"stylers": {
										"visibility": "off"
									}
								},
								{
									"featureType": "arterial",
									"elementType": "geometry",
									"stylers": {
										"color": "#004981"
									}
								},
								{
									"featureType": "arterial",
									"elementType": "geometry.fill",
									"stylers": {
										"color": "#00508b"
									}
								},
								{
									"featureType": "poi",
									"elementType": "all",
									"stylers": {
										"visibility": "off"
									}
								},
								{
									"featureType": "green",
									"elementType": "all",
									"stylers": {
										"color": "#056197",
										"visibility": "off"
									}
								},
								{
									"featureType": "subway",
									"elementType": "all",
									"stylers": {
										"visibility": "off"
									}
								},
								{
									"featureType": "manmade",
									"elementType": "all",
									"stylers": {
										"visibility": "off"
									}
								},
								{
									"featureType": "local",
									"elementType": "all",
									"stylers": {
										"visibility": "off"
									}
								},
								{
									"featureType": "arterial",
									"elementType": "labels",
									"stylers": {
										"visibility": "off"
									}
								},
								{
									"featureType": "boundary",
									"elementType": "geometry.fill",
									"stylers": {
										"color": "#029fd4"
									}
								},
								{
									"featureType": "building",
									"elementType": "all",
									"stylers": {
										"color": "#1a5787"
									}
								},
								{
									"featureType": "label",
									"elementType": "all",
									"stylers": {
										"visibility": "off"
									}
								}
						]
					}
				},
				series : [
					{
						name: 'pm2.5',
						type: 'scatter',
						coordinateSystem: 'bmap',
						data: convertData(data),
						symbolSize: function (val) {
							return val[2] / 10;
						},
						label: {
							normal: {
								formatter: '{b}',
								position: 'right',
								show: false
							},
							emphasis: {
								show: true
							}
						},
						itemStyle: {
							normal: {
								color: '#ddb926'
							}
						}
					},
					{
						name: 'Top 5',
						type: 'effectScatter',
						coordinateSystem: 'bmap',
						data: convertData(data.sort(function (a, b) {
							return b.value - a.value;
						}).slice(0, 6)),
						symbolSize: function (val) {
							return val[2] / 10;
						},
						showEffectOn: 'emphasis',
						rippleEffect: {
							brushType: 'stroke'
						},
						hoverAnimation: true,
						label: {
							normal: {
								formatter: '{b}',
								position: 'right',
								show: true
							}
						},
						itemStyle: {
							normal: {
								color: '#f4e925',
								shadowBlur: 10,
								shadowColor: '#333'
							}
						},
						zlevel: 1
					},
					{
						type: 'custom',
						coordinateSystem: 'bmap',
						renderItem: renderItem,
						itemStyle: {
							normal: {
								opacity: 0.5
							}
						},
						animation: false,
						silent: true,
						data: [0],
						z: -10
					}
				]
			};

			var renderItem = function(params, api) {
				var coords = [
					[121.48,31.22],
					[113.23,23.16],
					[108.95,34.27],
					[117.2,39.13]
				];
				var points = [];
				for (var i = 0; i < coords.length; i++) {
					points.push(api.coord(coords[i]));
				}
				var color = api.visual('color');

				return {
					type: 'polygon',
					shape: {
						points: window.echarts.graphic.clipPointsByRect(points, {
							x: params.coordSys.x,
							y: params.coordSys.y,
							width: params.coordSys.width,
							height: params.coordSys.height
						})
					},
					style: api.style({
						fill: color,
						stroke: window.echarts.color.lift(color)
					})
				};
			}

			this.map.setOption(option);
		}
	},
	watch:{
	}
}
</script>
